import { render } from "./UpdateGoalSkills.vue?vue&type=template&id=a31c1c14"
import script from "./UpdateGoalSkills.vue?vue&type=script&lang=js"
export * from "./UpdateGoalSkills.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__